import { CreateEnrollmentType } from "../../../types/Student";
import { post } from "../../../utils/axios-config";
import { ENROLLMENTS } from "../../../utils/constants";


export const createEnrollment = async (data: CreateEnrollmentType) => await post<CreateEnrollmentType, string>(ENROLLMENTS, data);